'use client';
import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import MernStackDevelopment from '@/components/technologies/mern-stack-demand';
import MernStackFAQ from '@/components/faqs/mern-stack';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="We specialize in MERN stack development services, empowering businesses to craft cutting-edge, scalable web applications by harnessing the capabilities of MongoDB, Express.js, React.js, and Node.js technologies."
                alt="MERN Stack Development"
                title="MERN Stack Development"
                width={1073}
                height={604}
                path={'mernstack-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                MERN Stack Development Company
            </TechHero>
            <DefaultBreadcrumb parentPage="Technology" isParent={true} currentPage="MERN Stack Development Company" />

            <ContetVideoSection title="Elevate Your Business with MERN Stack Development Services">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        In recent times, MERN has emerged as a leading technology favored by developers. Its rapid adoption is
                        attributed to its agility and effectiveness in meeting the demands of modern solutions. With industry
                        needs constantly evolving, businesses require robust technologies to keep pace, and MERN Stack is a prime
                        choice for building contemporary web applications. Comprising MongoDB, Express, React, and Node, the MERN
                        stack epitomizes the pinnacle of JavaScript technology.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        When you partner with Moweb Limited for MERN Stack development, you gain access to a fusion of technical
                        prowess, innovation, and creativity. Our web development services go beyond the mere implementation of a
                        standard tech stack.
                    </p>
                    <p className="fw-400 text-secondary fs-md  mb-0">
                        With years of experience in web and app development, our team excels in integrating third-party APIs and
                        libraries to enhance the robustness of your applications.
                    </p>
                </>
            </ContetVideoSection>
            <MernStackDevelopment />
            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire a MERN Stack Development Team to Build Your Next-Gen App"
                desc="Are you ready to embark on developing a next-generation web application that captivates your users? Entrust our highly skilled developers to craft tailor-made MERN Stack web applications precisely tailored to meet your unique business requirements."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb for Your MERN Stack Development Needs?" />
            <ModelsOfWorking
                title="Engagement Models for Hiring Premier MERN Stack Developers"
                desc="Choose from a variety of engagement models to hire MERN Stack developers tailored to your business requirements. Our diverse options ensure you find the perfect match, whether you need seasoned experts or the flexibility to adapt as needed."
            />
            <TechnologyFaq title="FAQs On MERN Stack Development Services" bg="bg-grey">
                <MernStackFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
